module.exports = __webpack_public_path__ + "static/img/5.52b9dff.png";


//////////////////
// WEBPACK FOOTER
// ./src/district/assets/image/home/5.png
// module id = iBW/
// module chunks = 3